<template>
    <div>
        <div class="top">
            <div class="flex">
                <a-statistic :title="item.title" :value="item.value" style="text-align: center" v-for="(item , index) in numList">
                    <template #suffix> </template>
                </a-statistic>
            </div>
            <div class="seachBox">
                <div class="seachList">
                    <span class="name">客户名称：</span>
                    <a-input placeholder="请输入" class="seachs" v-model="search.company"/>
                </div>
                <div class="seachList">
                    <span class="name">版 本：</span>
                    <a-select v-model="search.version_id" placeholder="请选择" class="seachs" allowClear >
                        <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.versionList">
                            {{item.name}}
                        </a-select-option>
                    </a-select>
                </div>
                <div class="seachList">
                    <span class="name">行 业：</span>
<!--                    <a-select v-model="search.industry_id" placeholder="请选择"  class="seachs" allowClear  >-->
<!--                        <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.industryList">-->
<!--                            {{item.name}}-->
<!--                        </a-select-option>-->
<!--                    </a-select>-->
                  <a-cascader class="seachs"  :load-data="loadData"   :fieldNames="fieldNames"
                              v-model="search.industry_id"
                              :options="seachList.industry"
                              change-on-select placeholder="请选择"
                  />
                </div>
                <div class="seachList"><span class="name">模板编号：</span>
                    <a-input placeholder="" class="seachs"   v-model="search.template_id"/>
                </div>
<!--                <div class="seachList">-->
<!--                    <span class="name">客户地区：</span>-->
<!--                    <a-select v-model="search.team_id" class="seachs" allowClear mode="multiple" placeholder="请选择" :showArrow="true">-->
<!--                        <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.team">-->
<!--                            {{item.team_name}}-->
<!--                        </a-select-option>-->
<!--                    </a-select>-->
<!--                </div>-->
                <div class="seachList">
                    <span class="name">网站类型：</span>
                    <a-select v-model="search.site_type" placeholder="请选择"  class="seachs" allowClear  >
                        <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.siteTypeList">
                            {{item.name}}
                        </a-select-option>
                    </a-select>
                </div>
                <div class="seachList"><span class="name">上线日期：</span>
                    <a-range-picker class="seachs" v-model="online_time" allowClear :showTime="false"  format="YYYY-MM-DD" @change="(date,dateString) => onChangeTime(date,dateString,'online_time')"/>
                </div>
                <div class="seachList"><span class="name">到期日期：</span>
                    <a-range-picker class="seachs" v-model="expire_time" allowClear :showTime="false"  format="YYYY-MM-DD" @change="(date,dateString) => onChangeTime(date,dateString,'expire_time')"/>
                </div>
              <div class="seachList"><span class="name">售后：</span>

              <a-input  v-model="search.aftermarket_name"  class="seachs" placeholder="请输入售后搜索" allowClear/>
              </div>
                <div class="seachList mgl20">
                    <a-button type="primary" class="top_btn" @click="getList()">搜索</a-button>
                    <a-button class="top_btn" @click="empty">重置</a-button>
                </div>
            </div>
        </div>
        <div class="flex" >
            <div><a-button class="top_btn" type="primary"   @click="exportList()"  >
                批量导出
            </a-button>
                <span style="margin-left: 8px">
        <template v-if="hasSelected">
          {{ `选中 ${selectedRowKeys.length} 项` }}
        </template></span></div>

        </div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id" @change="handleChange" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" >
            <span slot="list_order" slot-scope="text, record">
                <a-input placeholder=" " v-model="record.list_order" class="inputs" size="small"/>
            </span>
          <span slot="industry_name" slot-scope="text, record" :title="text" style="word-break:break-all;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;" >{{text}}</span>

          <span slot="action" slot-scope="text, record">
                <a @click="gotoStatistics(record)">查看 </a>
                <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm([record.id])"
                  @cancel="()=>{}"
          >
                <a  v-has="'btn_delete'">删除</a>
                </a-popconfirm>
      </span>
        </a-table>

    </div>

</template>

<script>
    import API from "./api";
    import moment from 'moment';
    import axios from "../../../utils/request"
    const columns = [

        {
            title: "客户名称",
            key: "company",
            width:"150px",
            ellipsis: true,
            dataIndex: "company",
        },
        {
            title: "浏览量（PV）",
            key: "pv_total",
            ellipsis: true,
            width:"150px",
            dataIndex: "pv_total",
            sorter: true,
        },
        {
            title: "访客量（UV）",
            key: "uv_total",
            ellipsis: true,
            width:"150px",
            dataIndex: "uv_total",
            sorter: true,
        },
        {
            title: "询盘量",
            key: "inquiry_num_count",
            ellipsis: true,
            dataIndex: "inquiry_num_count",
            sorter: true,
        },
        {
            title: "产品数",
            key: "product_num_count",
            ellipsis: true,
            dataIndex: "product_num_count",
            sorter: true,
        },

      {
        title: "行业",
        dataIndex: "industry_name",

        width: "200px",
        key: "industry_name",
        scopedSlots: {customRender: "industry_name"}
      },
        {
            title: "版本",
            key: "version_name",
            ellipsis: true,
            dataIndex: "version_name",
        },
        {
            title: "网站类型",
            key: "site_type_name",
            ellipsis: true,
            dataIndex: "site_type_name",width: "150px",
        },
        {
            title: "模板编号",
            key: "template_name",
            ellipsis: true,
            dataIndex: "template_name",
        },
        {
            title: "30天内登录次数",
            key: "thirty_days_login_num_count",
            ellipsis: true,
            dataIndex: "thirty_days_login_num_count",
            sorter: true,
        },
        {
            title: "操作",
            key: "action",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: 'index',
        data() {
            return {fieldNames: {label: 'name', value: 'id', children: 'children'},
                loading: true,
                data: [],
                numList:[
                    {title: "总建站数", value:""},
                    {title: "本月建站", value:""},
                    {title: "昨天建站", value:""},

                  {title: "总活跃数", value:""},
                  {title: "近30天活跃数", value:""},
                  {title: "近7天活跃数", value:""},
                ],
                selectedRowKeys: [], // Check here to configure the default column
                columns,
                key_word:"",
                search: {
                  aftermarket_name:'',
                    company:"",
                    version_id:undefined,
                    industry_id:undefined,
                    template_id:undefined,
                    // team_id:[],
                    site_type:undefined,
                    online_time:"",
                    expire_time:""
                },
                seachList:{
                    versionList:[],
                  industry:[],
                    team:[],
                    siteTypeList:[]
                },
                page:1,
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                online_time:"",
                expire_time:""
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/DataStatistics/WebStatistics"; //设置左侧导航2-2 active
        },
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods: {
          loadData(selectedOptions) {
            const targetOption = selectedOptions[selectedOptions.length - 1];
            targetOption.loading = true;
            let THAT=this
            API.service.GET_INDUSTRY_LIST({parent_id: selectedOptions[selectedOptions.length-1].id}).then(res => {
              targetOption.loading = false;
              targetOption.children = res.data.data
              THAT.seachList.industry=[...THAT.seachList.industry]
            })

          },
            // 表格排序
            handleChange(pagination, filters, sorter) {
                if(sorter.order) {
                    let sort=sorter.order=="ascend"?"ASC":"DESC"
                    this.search.order_field=sorter.columnKey
                    this.search.order_sort=sort
                }else{
                    delete this.search.order_field
                    delete this.search.order_sort
                }
                let seachData = JSON.parse(JSON.stringify(this.search))
                API.service.GET_LIST({page: this.page || 1, ...seachData}).then(res => {
                    this.selectedRowKeys=[]
                    this.data = res.data.data.data
                    this.pagination.total=res.data.data.total
                    this.pagination.pageSize=res.data.data.per_page
                    this.pagination.current=res.data.data.current_page
                    this.loading = false
                })
            },
            // 查看
            gotoStatistics(row){
                this.$router.push(`/DataStatistics/WebStatisticsDetails?id=${row.id}`)
            },
            exportList(){
                let seachData = JSON.parse(JSON.stringify(this.search))
                API.service.EXPORT( {  ...seachData,ids:this.selectedRowKeys } ).then(res => {
                    window.open( `${this.$store.state.urlExper}${res.data.data.path.substr(1)}`  )
                    // this.selectedRowKeys=[]
                })
            },
            getList(page,importantId) {
                this.page=page
                let seachData = JSON.parse(JSON.stringify(this.search))
                API.service.GET_LIST({page: page || 1, ...seachData,'important_id':importantId}).then(res => {
                    this.selectedRowKeys=[]
                    this.data = res.data.data.data
                    this.pagination.total=res.data.data.total
                    this.pagination.pageSize=res.data.data.per_page
                    this.pagination.current=res.data.data.current_page
                    this.loading = false
                })
            },
            getIndexAjax(){
                API.service.INDEX_AJAX().then(res => {
                    this.numList=[
                        {title: "总建站数", value: res.data.data.web_count.all_count},
                        {title: "本月建站", value:res.data.data.web_count.thirtyday_count},
                        {title: "昨天建站", value:res.data.data.web_count.yesterday_count},
                        ...res.data.data.login_statistics
                    ]
                    this.seachList.versionList=res.data.data.version

                    // this.seachList.team=res.data.data.team
                    this.seachList.siteTypeList=res.data.data.site_type

                })
            },
          getIndustry(){
            API.service.GET_INDUSTRY_LIST({parent_id:0}).then(res => {
              this.seachList.industry=res.data.data
            })
          },
            // 表格复选框选中
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            // 获取时间
            timeForMat(count){
                let time1 = new Date()
                time1.setTime(time1.getTime() - (24 * 60 * 60 * 1000))
                let Y1 = time1.getFullYear()
                let M1 = ((time1.getMonth() + 1) > 10 ? (time1.getMonth() + 1) : '0' + (time1.getMonth() + 1))
                let D1 = (time1.getDate() >= 10 ? time1.getDate() : '0' + time1.getDate())
                let timer1 = Y1 + '-' + M1 + '-' + D1 // 当前时间
                let time2 = new Date()
                time2.setTime(time2.getTime() - (24 * 60 * 60 * 1000 * count))
                let Y2 = time2.getFullYear()
                let M2 = ((time2.getMonth() + 1) > 10 ? (time2.getMonth() + 1) : '0' + (time2.getMonth() + 1))
                let D2 = (time2.getDate() >= 10 ? time2.getDate() : '0' + time2.getDate())
                let timer2 = Y2 + '-' + M2 + '-' + D2 // 之前的7天或者30天
                return {
                    t1: timer1,
                    t2: timer2
                }
            },
            selectInit(query){
                console.log(query)
                let importantId ;
                switch (query.type) {
                    case 'version':
                        this.search.version_id = parseInt(query.id)
                        break;
                    case 'industry':
                        this.search.industry_id =query.id.split(",").map(Number)
                        break;
                    case 'siteType':
                        this.search.site_type = parseInt(query.id)
                        break;
                    case 'important':
                        importantId = parseInt(query.id)
                        break;
                    case 'statisticalSummary':
                        console.log('statisticalSummary')
                        let timeObj;
                        if(query.days == 3){
                            // 昨天
                            timeObj = this.timeForMat(1)
                            this.search.online_time = timeObj.t2 + '~' +timeObj.t1
                            this.online_time=[moment(timeObj.t2,  'YYYY-MM-DD HH:mm:ss'), moment(timeObj.t1, 'YYYY-MM-DD HH:mm:SS')]
                        }else if(query.days == 2){
                            // 最近7天
                            timeObj = this.timeForMat(7)
                            this.search.online_time = timeObj.t2 + '~' +timeObj.t1
                            this.online_time=[moment(timeObj.t2,  'YYYY-MM-DD HH:mm:ss'), moment(timeObj.t1, 'YYYY-MM-DD HH:mm:SS')]
                        }else if(query.days == 1){
                            // 近30天
                            timeObj = this.timeForMat(30)
                            this.search.online_time = timeObj.t2 + '~' +timeObj.t1
                            this.online_time=[moment(timeObj.t2,  'YYYY-MM-DD HH:mm:ss'), moment(timeObj.t1, 'YYYY-MM-DD HH:mm:SS')]
                        }

                        break;
                    default:
                        break;
                }
                this.getList(1,importantId)
            },
            onChangeTime(date, dateString ,type) {
                console.log("改变了")
                this.type = date
                dateString[0] = moment(dateString[0]).format('YYYY-MM-DD')
                dateString[1] = moment(dateString[1]).format('YYYY-MM-DD')
                let dateStrings=`${dateString[0]}~${dateString[1]}`
                if(dateString[0] == 'Invalid date'){
                    dateStrings = ""
                }
                this.search[type] = dateStrings
            },
            empty(){
                this.search =  {
                    company:"",
                    version_id:undefined,
                    industry_id:undefined,
                    template_id:undefined,
                    // team_id:[],
                    site_type:undefined,
                    online_time:"",
                    expire_time:""
                }
                this.online_time = ""
                this.expire_time = ""
                this.getList(1)
            }
        },
        mounted() {
            // this.getList()
          let THAT=this
            this.getIndexAjax()
          this.getIndustry()
          let query={}
           if(THAT.$route.query.id){
             query=THAT.$route.query
             query.industry_id=THAT.$route.query.id.split(",")
           }
            console.log("this.$route.query",query)
            this.selectInit(query)
        }
    }
</script>
<style scoped>
    .inputs {
        display: inline-block;
        width: 70px
    }
    .search-group {
        float: right;
    }
    .search-group .ant-input {
        width: 200px;
        margin: 0 8px 0 0 ;
    }
    .button-group {
        float: left;
    }
    #list_order {
        width: 50px;
    }
    .top .flex{ box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);padding:10px 16px;box-sizing: border-box;width:100%;margin-bottom: 20px}
    .seachBox{
        display: flex;flex-wrap: wrap;
    }
    .mgl20{
        margin-left:18px
    }
</style>
